import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface ImageData {
    src?: string
    alt?: string
}

interface Content {
    title?: string
    subtitle?: string
    image1?: ImageData
    image2?: ImageData
    image3?: ImageData
    image4?: ImageData
}

interface S3_about_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_about_2Props) => {
    const { content = {} } = props
    const { title, subtitle, image1 = {}, image2 = {}, image3 = {}, image4 = {} } = content
    const imageOne = getImageData(image1)
    const imageTwo = getImageData(image2)
    const imageThree = getImageData(image3)
    const imageFour = getImageData(image4)
    return (
        <RegularSection aria-label='S3_about_2' >
            <Grid
                container
                spacing={4}
            >
                <Grid size={12}>
                    <ColorTitle title={title} colorFrom={0} textAlign='start'/>
                    <Grid size={12}>
                        <Typography
                            variant='body2'
                            sx={{ width: { xs: '100%', md: '40%' } }}
                        >
                            {subtitle}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    size={{ xs: 12, md: 8, lg: 5 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                    }}
                >
                    {imageOne.src ? (
                        <Image
                            src={imageOne.src}
                            alt={imageOne.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: 'auto', borderRadius: 10 }}
                        />
                    ) : null}
                </Grid>
                <Grid
                    size={{ xs: 12, md: 4, lg: 2 }}
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'row', md: 'column' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                    }}
                >
                    {imageTwo.src ? (
                        <Image
                            src={imageTwo.src}
                            alt={imageTwo.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: '50%', borderRadius: 10 }}
                        />
                    ) : null}
                    {imageThree.src ? (
                        <Image
                            src={imageThree.src}
                            alt={imageThree.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: '50%', borderRadius: 10 }}
                        />
                    ) : null}
                </Grid>
                <Grid
                    size={{ xs: 12, lg: 5 }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                    }}
                >
                    {imageFour.src ? (
                        <Image
                            src={imageFour.src}
                            alt={imageFour.alt || ''}
                            width={670}
                            height={360}
                            style={{ objectFit: 'cover', width: '100%', height: 'auto', borderRadius: 10 }}
                        />
                    ) : null}
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
